export default () => {
    $(".cmp-about-blog").find(".about").off('click').click(function(){
        $(".cmp-about-blog").find(".content").slideToggle();
        $(".fa-chevron-down").toggleClass("rotate");
    });

    $(".content").find(".close-icon").off('click').click(function(){
        $(".cmp-about-blog").find(".content").slideUp();
        $(".fa-chevron-down").removeClass("rotate");
    });
}
